import http from '@/utils/http' //引入axios
export const getDistrict = data => http.get('/rvm-center/api/district', {
    params: data
}) //查找地區
export const updataDistrict = data => http.put('/rvm-center/api/district', data) //編輯地區
export const addDistrict = data => http.post('/rvm-center/api/district', data) //添加地區
export const deleteDistrict = data => http.delete('/rvm-center/api/district', {
    params: data
}) //根据id删地區
export const findDistrict = data => http.get('/rvm-center/api/district/superior', {
    params: data
}) //查找地區
export default {
    getDistrict,
    updataDistrict,
    addDistrict,
    deleteDistrict,
    findDistrict
}